import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import Cookies from 'universal-cookie'
import { textTranslation, shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'

const cookies = new Cookies()

class FooterMin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      footerData: null,
    }
  }

  componentDidMount() {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          this.setState({
            footerData: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('footer', language)
  }

  render() {
    if (!this.state.footerData) {
      return null
    }
    return (
      <footer className="footer-new-min">
        <div className="copyright px-md-3 px-3 px-md-0 mt-4 mt-md-0">
          <div className="container">
            <FooterBar translated={this.state.footerData} />
          </div>
        </div>
      </footer>
    )
  }
}

const FooterBar = (props) => (
  <div className="row">
    <div className="col-12 col-sm-6">
      <p className="font-open-sans font-size-16 text-center text-sm-left">
        © {new Date().getFullYear()} Freebird Club
      </p>
    </div>
    <div className="col-12 col-sm-6">
      <nav className="navbar navbar-expand-lg navbar-light h-100 text-center text-sm-left justify-content-center justify-content-sm-right">
        <ul className="navbar-nav ml-sm-auto my-auto">
          <li className="nav-item active">
            <a
              id="lnk-footer-privacy"
              className="nav-link mr-0 mr-lg-4"
              href="/privacy-policy"
            >
              {decode(props.translated[9])}
            </a>
          </li>
          <li className="nav-item">
            <a
              id="lnk-footer-terms-of-supply"
              className="nav-link mr-0 mr-lg-4"
              href="terms-of-supply"
            >
              {decode(props.translated[10])}
            </a>
          </li>
          <li className="nav-item">
            <a
              id="lnk-footer-terms-conditions"
              className="nav-link"
              href="terms-conditions"
            >
              {decode(props.translated[11])}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
)

export default FooterMin
